import { frontendURL } from '../../../helper/URLHelper';
import SettingsWrapper from '../settings/SettingsWrapper.vue';
import ProfilePage from './ProfilePage.vue';
import ItemsPage from './ItemsPage.vue';

const meta = { permissions: ['administrator'] };

export const routes = [
  {
    path: frontendURL('accounts/:accountId/knowledge'),
    component: SettingsWrapper,
    children: [
      {
        path: '',
        redirect: to => ({ name: 'knowledge_company', params: to.params }),
      },
      {
        path: 'company',
        name: 'knowledge_company',
        meta,
        component: ProfilePage,
        props: { section: 'company' },
      },
      {
        path: 'ai-settings',
        name: 'knowledge_ai_settings',
        meta,
        component: ProfilePage,
        props: { section: 'ai' },
      },
      ...['products', 'services', 'faqs', 'policies'].map(resource => ({
        path: resource,
        name: `knowledge_${resource}`,
        meta,
        component: ItemsPage,
        props: { resource },
      })),
    ],
  },
];
